import React, { useMemo } from 'react';

// Selection des joueurs a deviner (chef) : jusqu'a maxAuthors auteurs choisis
// parmi TOUS les auteurs de TOUTES les sources.
// authors: [{ label, name, count }], kept: string[] (labels), onChange(labels[]).
// Si kept est vide, la selection par defaut = les maxAuthors plus actifs.
export function AuthorCurationPanel({ authors = [], kept = [], maxAuthors = 10, onChange }) {
  const sorted = useMemo(() => [...authors].sort((a, b) => b.count - a.count), [authors]);
  const effective = useMemo(
    () => (kept.length ? new Set(kept) : new Set(sorted.slice(0, maxAuthors).map((a) => a.label))),
    [kept, sorted, maxAuthors]
  );
  const count = sorted.filter((a) => effective.has(a.label)).length;

  if (!authors.length) return null;

  const toggle = (label) => {
    const next = new Set(effective);
    if (next.has(label)) next.delete(label);
    else {
      if (next.size >= maxAuthors) return; // plafond
      next.add(label);
    }
    onChange([...next]);
  };
  const selectTop = () => onChange(sorted.slice(0, maxAuthors).map((a) => a.label));

  return (
    <div style={{
      marginTop: '0.5rem', border: '2px solid var(--border-color)', borderRadius: 'var(--radius)',
      padding: '0.6rem', background: '#ffffff', color: '#2f3441',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '.5rem', flexWrap: 'wrap' }}>
        <strong style={{ fontSize: '0.82rem' }}>Joueurs a deviner : {count}/{maxAuthors}</strong>
        <button type="button" className="btn" style={{ padding: '.2rem .5rem', fontSize: '.72rem' }} onClick={selectTop}>Top {maxAuthors} actifs</button>
      </div>
      <div style={{
        marginTop: '0.5rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: '0.3rem', maxHeight: '26vh', overflowY: 'auto',
      }}>
        {sorted.map((a) => {
          const on = effective.has(a.label);
          const disabled = !on && count >= maxAuthors;
          return (
            <label key={a.label} style={{
              display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.25rem 0.4rem',
              border: '1px solid ' + (on ? 'var(--color-primary)' : 'var(--border-color)'),
              background: on ? 'rgba(86,99,247,0.12)' : '#fafafa',
              cursor: disabled ? 'not-allowed' : 'pointer', fontSize: '0.7rem', opacity: on ? 1 : (disabled ? 0.4 : 0.75),
            }}>
              <input type="checkbox" checked={on} disabled={disabled} onChange={() => toggle(a.label)} />
              <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.name || a.label}</span>
              <span style={{ opacity: 0.6 }}>{a.count}</span>
            </label>
          );
        })}
      </div>
      <div style={{ marginTop: '0.4rem', fontSize: '0.65rem', opacity: 0.7 }}>
        Choisis jusqu'a {maxAuthors} joueurs (toutes sources confondues). Minimum 2 pour lancer.
      </div>
    </div>
  );
}
